.o{width:100%;}